import * as types from './actionTypes';

export const setActiveKeywords = (activeKeywords) => {
  return {
    type: types.SET_ACTIVE_KEYWORDS,
    activeKeywords: activeKeywords
  };
}



// WEBPACK FOOTER //
// ./src/actions/actionsResume.js